import { Record } from "immutable";

import { TrialStateType } from "./trial/TrialState";

export type TrialsStateType = {
  wrongAnswers: TrialStateType | null;
};

const defaultTrialsState: TrialsStateType = {
  wrongAnswers: null
};

export default class TrialsState extends Record(defaultTrialsState) {}
